// Components
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProgressBar,
  ToastProgressUnderline,
  ToastProvider,
  ToastViewport,
  toastIconMap,
} from "@/components/ui/toast"

// Hooks
import { useToast } from "@/hooks/use-toast"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, description, action, variant, duration, progressStyle, ...props }) {
        const showProgress = typeof duration === 'number' && duration >= 5000 && isFinite(duration)
        const ProgressComponent = progressStyle === 'underline' ? ToastProgressUnderline : ToastProgressBar

        const { icon: Icon, colorClass } = toastIconMap[variant || 'default']

        return (
          <Toast key={id} variant={variant} duration={showProgress ? Infinity : duration} {...props}>
            {showProgress && <ProgressComponent duration={duration} onComplete={() => dismiss(id)} />}
            <div className="relative z-10 flex w-full items-center gap-2">
              <Icon className={`size-4 flex-shrink-0 ${colorClass}`} />
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
              {action}
              <ToastClose />
            </div>
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
